import { onLogicSuccess } from 'client/actions/Auth/login';

import {
  SR_API_ACTION_BUYER_SIDE_AGENT_SIGNUP,
} from 'api/actionTypes';

export default async function buyerSideAgentSignup({ state, apiClient }, payload) {
  await apiClient.postWithState({
    action: SR_API_ACTION_BUYER_SIDE_AGENT_SIGNUP,
    state: state,
    payload,
    async onSuccess({ user }) {
      await onLogicSuccess({
        state,
        apiClient,
        user,
      });
    },
  });
}
